import React, { useLayoutEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import AreasPage from "../pages/allianz/areas/areas";

import Error404Classic from "../pages/error/404-classic";
import Error404Modern from "../pages/error/404-modern";
import Error504Modern from "../pages/error/504-modern";
import Error504Classic from "../pages/error/504-classic";

import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import Success from "../pages/auth/Success";
import ProtectedRoute, { GuestRoute, RequiereAjuste } from "./../hooks/useProtected";
import { useAuth } from "./../context/auth.context";
import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";
import CommonName from "../pages/allianz/common-name/commonName";
import Family from "../pages/allianz/family/family";
import Specie from "../pages/allianz/specie/specie";
import Volunteer from "../pages/allianz/volunteer/volunteer";
import Location from "../pages/allianz/location/location";
import TreeType from "../pages/allianz/tree-type/tree-type";
import CampaignHomePage from "../pages/Campaign";
import ConfigurationPage from "../pages/allianz/webpage/configuration";
import GraphPage from "../pages/allianz/webpage/graph";
import ListTreePage from "../pages/allianz/tree/list-tree";
import Trees from "../pages/allianz/tree/create-tree";
import UserPage from "../pages/allianz/user/user";

const Pages = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route
          path=""
          element={
            <GuestRoute isAuthenticated={isAuthenticated}>
              <Login />
            </GuestRoute>
          }
        ></Route>
        <Route
          path="login"
          element={
            <GuestRoute isAuthenticated={isAuthenticated}>
              <Login />
            </GuestRoute>
          }
        ></Route>
        <Route path="auth-success" element={<Success />}></Route>

        <Route path="errors">
          <Route path="404-modern" element={<Error404Modern />}></Route>
          <Route path="404-classic" element={<Error404Classic />}></Route>
          <Route path="504-modern" element={<Error504Modern />}></Route>
          <Route path="504-classic" element={<Error504Classic />}></Route>
        </Route>
        <Route path="*" element={<Error404Modern />}></Route>
      </Route>
      <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>
        <Route
          path="dashboard"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <ListTreePage />
            </ProtectedRoute>
          }
        ></Route>

        <Route
          path="allianzer-areas"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <AreasPage />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="common-names"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <CommonName />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="family"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Family />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="specie"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Specie />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="volunteer-name"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Volunteer />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="location"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Location />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="tree-types"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <RequiereAjuste ajuste="tiposDeArbol">
                <TreeType />
              </RequiereAjuste>
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="trees"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <AreasPage />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="configurations"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <ConfigurationPage />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="graph"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <GraphPage />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="tree"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <Trees />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="users"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <UserPage />
            </ProtectedRoute>
          }
        ></Route>
      </Route>
    </Routes>
  );
};
export default Pages;
